import {
    React,
    useState,
    useActionUrl,
    CompanyRoutes,
    $,
    useEffect
} from 'library/base/baseContainerImports'

const SquareForm = ({ 
    authhash,
    environment,

}) => {
    const {getFullUrl}      = useActionUrl();
    const [loaded, setLoaded] = useState(false);
    const [squarePayments, setSquarePayments] = useState(undefined);

    const settingsModule    = CompanyRoutes.ADMIN.COMPANY_SIGNUP.SETTINGS;
    const settingAction     = getFullUrl(settingsModule.path, {authhash:authhash,load:'data'});

    const squareCDN = environment == 'staging' 
        ? 'https://sandbox.web.squarecdn.com/v1/square.js' 
        : 'https://web.squarecdn.com/v1/square.js';

    useEffect(() => {
        const existingScript = document.getElementById("webPayment")
        if (existingScript) setLoaded(true)
        else {
            const script = document.createElement("script")
            script.src = "https://sandbox.web.squarecdn.com/v1/square.js"
            script.id = "webPayment"
            document.body.appendChild(script)
            script.onload = () => {
                setLoaded(true)
            }
        }
    }, []);

    useEffect(() => {
        if (loaded && !squarePayments) {
          if (!window?.Square) {
            console.error("Square.js failed to load properly")
            return
          }
          setSquarePayments(window.Square?.payments('sandbox-sq0idb-KHSor8AFK9R4qpWljg6Oug', 'LSHMWY3YE61J3'));
        }
    }, [loaded, squarePayments]);
      
    useEffect(() => {
        if (squarePayments) {
            initializeSquareCard();
        }
    }, [squarePayments]);

    const loadSettings = () => {
        $.get(settingAction, function (data) {
            
        });
    };

    const initializeSquareCard = async () => {
        const card = await squarePayments.card()
        attachCard(card);
    }

    const attachCard = (card) => {
        card.attach("#card-container");
    }

    const handleSquarePayment = () => {
        
    }

    return (
        <form 
            id="payment-square-form"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <div id="card-container"></div>
            <button 
                id="card-button"
                type="button"
                onClick={handleSquarePayment}
            >
                Pay
            </button>
        </form>
    );
};

export default SquareForm;
